var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08627 12C2.08627 6.06294 6.89921 1.25 12.8363 1.25C18.7733 1.25 23.5863 6.06294 23.5863 12C23.5863 17.9371 18.7733 22.75 12.8363 22.75C6.89921 22.75 2.08627 17.9371 2.08627 12ZM7.88608 13.2998C8.57643 13.2998 9.13608 12.7402 9.13608 12.0498C9.13608 11.3594 8.57643 10.7998 7.88608 10.7998C7.19572 10.7998 6.63608 11.3594 6.63608 12.0498C6.63608 12.7402 7.19572 13.2998 7.88608 13.2998ZM14.1361 12.0498C14.1361 12.7402 13.5764 13.2998 12.8861 13.2998C12.1957 13.2998 11.6361 12.7402 11.6361 12.0498C11.6361 11.3594 12.1957 10.7998 12.8861 10.7998C13.5764 10.7998 14.1361 11.3594 14.1361 12.0498ZM17.8861 13.2998C18.5764 13.2998 19.1361 12.7402 19.1361 12.0498C19.1361 11.3594 18.5764 10.7998 17.8861 10.7998C17.1957 10.7998 16.6361 11.3594 16.6361 12.0498C16.6361 12.7402 17.1957 13.2998 17.8861 13.2998Z",
    fill: "#A1A3A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMore);
export default __webpack_public_path__ + "static/media/circle-more.f07535a12cf91d010211debf892df3ec.svg";
export { ForwardRef as ReactComponent };